/* eslint-disable react/no-unknown-property */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import TextPlaceholder from 'Component/TextPlaceholder';
import { ProductType } from 'Type/ProductList.type';

import './ProductLabel.extended.style';

/** @namespace Scandipwa/Component/ProductLabel/Component */
export class ProductLabelComponent extends PureComponent {
    static propTypes = {
        product: ProductType,
        // eslint-disable-next-line react/boolean-prop-naming
        areDetailsLoaded: PropTypes.bool,
        isPDP: PropTypes.bool,
        isBadge: PropTypes.bool
    };

    static defaultProps = {
        product: {},
        areDetailsLoaded: false,
        isPDP: false,
        isBadge: false
    };

    renderProductLabel() {
        const {
            product: {
                label_text,
                label_color_background,
                label_color_foreground,
                product_badge
            },
            areDetailsLoaded,
            isPDP,
            isBadge
        } = this.props;

        const labelStyle = {
            color: label_color_foreground,
            backgroundColor: label_color_background
        };

        const pseudoElementStyle = {
            borderColor: `transparent ${label_color_background} transparent transparent`
        };

        if (isBadge) {
            if (product_badge) {
                return (
                    <div
                      block="ProductLabel"
                      mods={ { BadgeLabel: true } }
                      style={ labelStyle }
                    >
                        { product_badge }
                    </div>
                );
            }

            return null;
        }

        if (!areDetailsLoaded && isPDP) {
            return (
                <div
                  block="ProductLabel"
                  elem="Placeholder"
                >
                    <TextPlaceholder content={ false } length="short" />
                </div>
            );
        }

        if (!label_text) {
            return null;
        }

        return (
            <div
              block="ProductLabel"
              style={ labelStyle }
            >
                { label_text }
                <div block="ProductLabel" elem="PseidoElement" style={ pseudoElementStyle } />
            </div>
        );
    }

    render() {
        return this.renderProductLabel();
    }
}

export default ProductLabelComponent;
